import { Localizable } from '@components/localizable/Localizable'
import { Currency } from '@models/Currency'
import {
  SBAsyncSelect,
  SBAsyncSelectProps,
} from '@supplement-bacon/react-async-select'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { SBRMFormActionProps, useSBRMForm } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import MetadataKey from '@utils/MetadataKey'
import { requiredRule } from '@utils/rules'
import { Form, Input, InputNumber } from 'antd'
import { useCallback } from 'react'

const initialValues = {
  amount: 1,
}

type Props = SBRMFormActionProps & {
  error?: string
}

const Create = ({ form, formProps, error }: Props) => {
  const { metadata, getMetadata } = useSBRMForm()

  const programId: () => number = useCallback(
    () => getMetadata(MetadataKey.Program),
    [getMetadata, metadata]
  )

  return (
    <Form
      {...formProps}
      form={form}
      layout="vertical"
      initialValues={initialValues}
    >
      <Form.Item
        name="program"
        rules={[]}
        hidden
        style={{ display: 'none' }}
        initialValue={programId()}
      >
        <Input type="hidden" />
      </Form.Item>

      <Localizable.Input
        name="name"
        rules={[requiredRule()]}
        label={'Name'}
        max={70}
      />

      <Form.Item
        name="currency"
        label={'Currency'}
        rules={[requiredRule()]}
        validateStatus={error && 'error'}
        help={error}
      >
        <SBAsyncSelect<Currency>
          entity={Entity.currency}
          initialQuery={
            {
              ...initialQuery,
              filters: { programs: [programId()] },
            } as SBAsyncSelectProps<Currency>['initialQuery']
          }
        />
      </Form.Item>

      <Form.Item name="amount" label={'Amount'} rules={[requiredRule()]}>
        <InputNumber mode="spinner" style={{ width: '100%' }} min={1} />
      </Form.Item>
    </Form>
  )
}

export default Create
